// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._c71lidpf{max-height:0}\n._kqswstnw{position:absolute}\n._p12fidpf{max-width:0}", ""]);
// Exports
module.exports = exports;
